import React from "react"
import { SurveyContentType } from "models/generated"

export const SurveyContentTypeContext = React.createContext<SurveyContentType | undefined>(undefined)

export const SurveyContentTypeProvider: React.FC<{ value?: SurveyContentType }> = ({ children, value }) => {
  return (
    <SurveyContentTypeContext.Provider value={value}>
      {children}
    </SurveyContentTypeContext.Provider>
  )
}
